import React from 'react';
import { observer } from 'mobx-react';

import ListHeader from 'components/drill-down-layout/components/list/components/list-header';

const KiosksListHeader = ({
  filter,
  setFilter,
}) => (
  <ListHeader
    title='Kiosks'
    searchValue={filter}
    onSearch={(e) => setFilter(e)}
  />
);

export default observer(KiosksListHeader);
